export default __webpack_public_path__ + "sounds/58de9c2a326f48f24b7b89fca2928866.mp3";